module.exports = __webpack_public_path__ + "static/media/Q-Clubs.b97e276c.svg";